<template>
    <div class="featuredFilter" @click="runFeaturedQuickFilter()">
        {{ this.featuredQuickFilter.display }}
    </div>
</template>

<script>
    export default {
        computed: {
            featuredQuickFilter() {
                return this.$store.getters.getQuickFilters['qfFreeLifetimeWarrantry'];
            }
        },
        methods: {
			runFeaturedQuickFilter() {
				let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('select', {'event_category': 'quick_filter','event_label': eventLabel});
                this.$store.dispatch('applyQuickFilterSelected', this.featuredQuickFilter);
			}
        }
    }
</script>

<style>
    .featuredFilter {
        color: white;
        padding: calc(1.2 * var(--vh)) calc(1 * var(--vw));
        text-align: center;
        border-top: 1px solid #545454;
        border-bottom: 1px solid #2B2A2B;
        cursor: pointer;
        /*background-color: #00b63d;*/
    }

    .featuredFilter:hover {
        /*color: black;*/
        color: var(--mccluskeyGold); /*#AF873F;*/
        border-color: var(--mccluskeyGold); /*#AF873F;*/
        border-top: 1px solid;
    }
</style>